import {
  TagContainer, TagHeader, TagHeaderColumn, TagInformationFooter, Text,
} from './ReceivementFreshTag.style'
import { TagHeaderRow } from './TagHeaderRow'
import { TagSection } from './TagSection'

// TODO: Passar ReceivementFreshForm para typescript e, modificar essa interface de acordo com o objeto
interface ReceivementFreshTagProps {
  obj: any
}

const ReceivementFreshTag = (props: ReceivementFreshTagProps): JSX.Element => {
  const {
    address, description, entryDate, expirationDate, modelId, barcode, lot, fc, currentToPrint,
  } = props.obj

  const [entryDateValue, entryTimeValue] = entryDate.split(' ')
  const [fcId, fcName] = fc.split(' - ')

  return (
    <TagContainer>
      <TagHeader>
        <TagHeaderColumn hasRightBorder centered>
          <Text limit={130}>{fcId}</Text>
          <Text limit={130}>{fcName}</Text>
        </TagHeaderColumn>
        <TagHeaderColumn hasRows>
          <TagHeaderRow
            description='Entrada'
            date={entryDateValue}
            additionalInfo={entryTimeValue}
            hasBorder
          />
          <TagHeaderRow
            description='Validade'
            date={expirationDate}
            additionalInfo={currentToPrint}
            separateAdditionalInfo
          />
        </TagHeaderColumn>
      </TagHeader>

      <TagSection name='Endereço' value={address} />

      <TagSection
        flexSize={2}
        name='SKU'
        description={description}
        value={barcode}
        footer={(
          <TagInformationFooter>
            <Text size={14}>{modelId}</Text>
            <Text size={14}>{barcode}</Text>
          </TagInformationFooter>
        )}
        hasBorders
      />

      <TagSection name='Lote' value={lot.toString()} />
    </TagContainer>
  )
}

export { ReceivementFreshTag }
